import { useQuery } from "@tanstack/react-query";

export interface DiscoveredConnection {
  companyId: string;
  companyName: string;
  companyCategory: string | null;
  threadCount: number;
  lastTouchAt: string;
}

export function useCoiDiscovered(coiId: string | undefined) {
  return useQuery<DiscoveredConnection[]>({
    queryKey: ["coi-discovered", coiId],
    queryFn: async () => {
      const r = await fetch(`/api/cois/${coiId}/discovered-connections`, { credentials: "include" });
      if (!r.ok) throw new Error("Failed to load discovered");
      return r.json();
    },
    enabled: !!coiId,
    staleTime: 60_000,
  });
}
